import type {
  TagAssignment,
  UserAssignment,
} from "settings/account/components/TagsManager/types";
import {
  tagWireToNotificationResourceType,
} from "settings/account/types/tag-resource-types";
import type {
  AddMemberInput,
  DraftResourceAssignment,
  GroupTagResource,
} from "../types";

export { tagWireToNotificationResourceType as tagServiceTypeToNotificationResourceType };

function wireResourceToDraftRow(
  wireResourceType: string,
  resourceId: number | string,
  resourceLabel?: string | null,
  resourceSubtitle?: string | null
): DraftResourceAssignment | null {
  const resourceType = tagWireToNotificationResourceType(wireResourceType);
  if (!resourceType) return null;
  return {
    resourceType,
    resourceId: String(resourceId),
    eventTypes: null,
    resourceDisplayHint: resourceLabel ?? null,
    resourceSubtitle: resourceSubtitle ?? null,
  };
}

export function tagAssignmentsToDraftRows(
  assignments: TagAssignment[]
): DraftResourceAssignment[] {
  const out: DraftResourceAssignment[] = [];
  for (const a of assignments) {
    const row = wireResourceToDraftRow(
      a.serviceType,
      a.resourceId,
      a.resourceLabel,
      a.resourceSubtitle
    );
    if (row) out.push(row);
  }
  return out;
}

/** Maps embedded `GET /groups/:id` → `tagResources` into wizard draft rows. */
export function tagResourcesToDraftRows(
  resources: GroupTagResource[]
): DraftResourceAssignment[] {
  const out: DraftResourceAssignment[] = [];
  for (const r of resources) {
    const row = wireResourceToDraftRow(
      r.resourceType,
      r.resourceId,
      r.resourceLabel,
      r.subtitle
    );
    if (row) out.push(row);
  }
  return out;
}

/** Count tag rows that cannot be projected (for UI hints). */
export function countUnmappedTagAssignments(assignments: TagAssignment[]): number {
  return assignments.filter(
    (a) => !tagWireToNotificationResourceType(a.serviceType)
  ).length;
}

export function tagUserAssignmentsToMemberInputs(
  users: UserAssignment[]
): AddMemberInput[] {
  return users.map((u) => ({
    type: "user" as const,
    auth0Id: u.auth0Id,
    email: u.email,
    displayName: u.displayName ?? undefined,
  }));
}
